// Where an assignment was created, as the API's sourceSystem fields return it. Assignments made in the MX assign apps
// come through the API; any other source is Instruction Hub. What each other value stands for isn't settled yet.
export enum AssignmentSourceSystem {
    Api = 0,
    AssignmentEventConsumer = 1,
    CompletionConsumer = 2,
    Migration = 3,
    Maintenance = 4,
    ActivityCompletionConsumer = 5
}

export type InstructionHubAssignmentIds = {
    instructionHubAssignmentId: string | number | null
    instructionHubActivityId: string | number | null
};

export type InstructionHubAssignmentMetadata = InstructionHubAssignmentIds & {
    isInstructionHubAssignment: boolean
};

export type InstructionHubFlags = {
    isInstructionHubEnabled: boolean
    isInstructionHubResultsEnabled: boolean
};

export type InstructionHubState = {
    isInstructionHubAssignment: boolean
    isInstructionHubResult: boolean
};
